// extracted by mini-css-extract-plugin
export default {"container":"authLayout_container__OXfXO","fadeDown":"authLayout_fadeDown__8Vn-R","logo":"authLayout_logo__i-tBp"};